export const Radio = {
  baseStyle: {
    label: {
      color: 'brand.formInput',
      _checked: {
        color: 'brand.formInput',
      },
    },
    control: {
      height: '20px',
      width: '20px',
      _checked: {
        color: 'brand.formInput',
        backgroundColor: 'white',
        borderColor: 'gray.300',
        _hover: {
          backgroundColor: 'white',
          borderColor: 'gray.300',
        },
      },
    },
  },
  variants: {
    admin: {
      label: {
        color: 'brand.formInput',
      },
      control: {
        borderWidth: '1px',
        borderColor: 'gray.300',
        _checked: {
          color: 'brand.formInput',
          borderColor: 'brand.formInput',
          _hover: {
            color: 'brand.formInput',
            borderColor: 'brand.formInput',
          },
        },
      },
    },
    warmNeutral: {
      label: {
        fontSize: '14px',
        fontWeight: 400,
        color: 'baseBlack',
      },
      control: {
        borderColor: 'warmNeutral.600',
        _checked: {
          backgroundColor: 'warmNeutral.600',
          borderColor: 'warmNeutral.600',
          color: 'warmNeutral.600',
          _hover: {
            backgroundColor: 'warmNeutral.600',
            borderColor: 'warmNeutral.600',
          },
        },
      },
    },
  },
};
